import { render } from "./AddToWishList.vue?vue&type=template&id=2583827d&scoped=true"
import script from "./AddToWishList.vue?vue&type=script&lang=js"
export * from "./AddToWishList.vue?vue&type=script&lang=js"

import "./AddToWishList.vue?vue&type=style&index=0&id=2583827d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2583827d"]])

export default __exports__